module.exports = __webpack_public_path__ + "static/media/deployment.1f2b36bb.png";